import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import TragusPiercingImage from '../../Assets/Piercing Services/tragus piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function TragusPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Tragus Piercing UAE | 150 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Tragus Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Tragus Piercing 150 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={TragusPiercingImage} alt="Tragus Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Tragus Piercing</h3>

          <p>
            Enhance your ear styling with our professional tragus piercing services in the UAE, available at an affordable price of 150 AED. Tragus piercing is a delicate and stylish option placed on the small cartilage located in front of the ear canal, offering a subtle yet modern look that perfectly complements both casual and elegant styles. This unique piercing has become increasingly popular among those who want to add a refined and trendy touch to their appearance without going too bold. Whether you prefer a minimal stud or a sleek hoop, our expert specialists ensure precise placement for a balanced and aesthetically pleasing result.
          </p>

          <p>
            At our piercing studio, we prioritize safety, hygiene, and comfort to deliver a premium experience for every client. Our certified professionals use sterile, single-use, high-quality equipment to perform each tragus piercing with accuracy and care. We follow strict hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth procedure. Our goal is to provide a quick, efficient, and pain-minimized experience, making tragus piercing suitable for both first-time clients and those looking to expand their ear piercing collection.
          </p>

          <p>
            Tragus piercing is an excellent choice for individuals who want a distinctive yet understated look. Its placement makes it versatile and easy to style with different types of jewelry, allowing you to switch between simple and statement pieces effortlessly. Our specialists take the time to understand your preferences and guide you in selecting the ideal jewelry and placement that best suits your ear structure and personal style. With expert consultation, we ensure that your piercing enhances your overall appearance while maintaining comfort.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for those with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that you feel relaxed from the moment you walk in. We understand that cartilage piercings can feel intimidating for some clients, and our friendly staff is always available to answer your questions and provide reassurance throughout the process. From consultation to completion, we focus on delivering a positive and comfortable experience.
          </p>

          <p>
            Aftercare is an essential part of maintaining your tragus piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper care, tragus piercings heal effectively and remain a long-lasting and stylish addition to your look.
          </p>

          <p>
            Our tragus piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted tragus piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a delicate and trendy look effortlessly. Book your tragus piercing appointment today and elevate your ear style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Tragus Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TragusPiercing;